/**
 * <s-footer-accordion>
 * Wraps one footer menu <details>. Below the breakpoint the menu collapses and
 * toggles natively; at or above it the menu is forced open and the summary no
 * longer toggles, so desktop keeps the classic always-visible columns.
 * The markup renders `open`, so menus stay visible without JavaScript.
 */
class SFooterAccordion extends HTMLElement {
  #details = null;
  #summary = null;
  #query = null;
  #onChange = () => this.#sync();
  #onSummaryClick = (event) => {
    if (this.#query?.matches) event.preventDefault();
  };

  connectedCallback() {
    this.#details = this.querySelector('details');
    this.#summary = this.#details?.querySelector('summary');
    if (!this.#details || !this.#summary) return;

    this.#query = window.matchMedia(this.dataset.desktopQuery || '(min-width: 640px)');
    this.#query.addEventListener('change', this.#onChange);
    this.#summary.addEventListener('click', this.#onSummaryClick);
    this.#sync();
  }

  disconnectedCallback() {
    this.#query?.removeEventListener('change', this.#onChange);
    this.#summary?.removeEventListener('click', this.#onSummaryClick);
  }

  #sync() {
    const desktop = this.#query.matches;
    this.#details.open = desktop;
    if (desktop) {
      this.#summary.setAttribute('tabindex', '-1');
    } else {
      this.#summary.removeAttribute('tabindex');
    }
  }
}

if (!customElements.get('s-footer-accordion')) {
  customElements.define('s-footer-accordion', SFooterAccordion);
}
